import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import LinkIcon from '@material-ui/icons/Link';
import * as R from 'ramda';
import React from 'react';
import { OpenPosition, ROLE_HUMAN_NAMES } from '../../models/jobs';
import TechnicalSkill from '../../models/technical-skills';
import TechnicalSkillChips from '../TechnicalSkillChips';

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardContentRoot: {
    paddingTop: 0,
    flex: 1,
  },
  companyLogo: {
    boxShadow: '#c9c9c9 0px 1px 4px',
    '& > img': {
      objectFit: 'contain',
    },
  },
  cardChips: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    '& > *': {
      marginRight: theme.spacing(1),
    },
  },
}));

interface OpenPositionCardProps {
  position: OpenPosition;
  skills?: TechnicalSkill[];
  actions?: React.ReactNode;
}

export default function OpenPositionCard({ position, skills, actions }: OpenPositionCardProps) {
  const classes = useStyles();
  const { company } = position;
  return (
    <Grid item xs={12} md={6} lg={4} xl={3}>
      <Card classes={{ root: classes.cardRoot }}>
        <CardHeader
          avatar={(
            <Avatar aria-label="Company Logo" alt="Company Logo" className={classes.companyLogo} src={company.logoUrl ? `https://matilda-storage-${(process.env.REACT_APP_ENV === 'production') ? 'prod' : 'dev'}.s3.amazonaws.com/companies/${company.id}.${company.logoUrl}` : undefined}>
              {R.head(company.name)}
            </Avatar>
          )}
          title={company.name}
          titleTypographyProps={{ variant: 'h5' }}
          action={company.url && <Link href={company.url} target="_blank"><LinkIcon fontSize="large" /></Link>}
        />
        <CardContent classes={{ root: classes.cardContentRoot }}>
          <Typography variant="h5">
            {position.name}
          </Typography>
          <Box className={classes.cardChips}>
            <Chip label={ROLE_HUMAN_NAMES[position.role]} size="small" />
            <TechnicalSkillChips
              skills={skills}
              showFrequency
              small
              noContainer
            />
          </Box>
          <Typography variant="body2">{position.company.summary}</Typography>
        </CardContent>
        {Boolean(actions) && (
          <CardActions>
            {actions}
          </CardActions>
        )}
      </Card>
    </Grid>
  );
}
